export const formatIceServers = (iceServers: any) =>
  iceServers.map((iceServer: any) => ({
    url: iceServer.urls[0],
    username: iceServer.username,
    password: iceServer.credential,
  }));
